import React, { useState } from "react";
import { toast } from "react-toastify";
import { Form, Button, Container, Row, Col, Card } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import ApiService from "../services/ApiService";
import logo from "../assets/img/mse-logo.webp";
import Footer from "../components/Footer/Footer";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const Login = () => {
  const navigate = useNavigate();
  const [isLoader, setIsLoader] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const [formData, setFormData] = useState({
    username: "",
    password: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };
  const handlePhone = (val) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      ['phone']: val,
    }));
    console.log(formData);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoader(true);
    try {
      const response = await ApiService.request({
        method: "POST",
        url: `register`, // Replace with your API endpoint
        data: formData,
      });
      const data = response.data;
      if (data.status) {
        toast.success(data.message);
        let user = data.data.user;
        // user.auth_token = data.data.auth_token;
        // localStorage.setItem("user", JSON.stringify(data.data.user));
        // window.location.href = "/dashboard";
        navigate("/verify-email?user_id="+user.id);
      } else {
        toast.error(data.message);
      }
      setIsLoader(false);
    } catch (error) {
      toast.error("Registration failed!");
      setIsLoader(false);
    }
  };

  return (
    <>
      <div>
        <div className="topbar-border">
          <div className="nav-logo px-3 py-2">
            <img src={logo} alt="MSE Logo" />
          </div>
        </div>

        <Container fluid className="mt-3 p-0 signIn-form">
          <div className="text-center header">
            <h1 className="fw-light pb-3">MSE</h1>
          </div>

          <Row className="justify-content-center">
            <Col md={8} className="p-4 ">
              <h4 className="mb-3">Sign Up</h4>
              <p>
                Our secure website encrypts your personal information so that it
                cannot be read by unauthorized Internet users. For your
                security, please remember to sign out of your account and close
                your browser when you finish your session.
              </p>
              <p>
                Please do not use the back button to navigate the site. <br />
                <span className="text-danger">* Required information</span>
              </p>
            </Col>
            <Col md={5} className="signIn-form">
              <Card className="p-4">
                <h5 className="fw-light mb-4">Sign Up:</h5>

                <Form onSubmit={handleSubmit}>
                  <Form.Group controlId="username" className="mb-3">
                    <Form.Label>* Username:</Form.Label>
                    <Form.Control
                      type="text"
                      required
                      className="w-50 inp-s"
                      name="username"
                      value={formData.username}
                      onChange={handleChange}
                    />
                  </Form.Group>
                  <Form.Group controlId="username" className="mb-3">
                    <Form.Label>* Email:</Form.Label>
                    <Form.Control
                      type="email"
                      name="email"
                      required
                      className="w-50 inp-s"
                      onChange={handleChange}
                    />
                  </Form.Group>

                  <Form.Group controlId="password" className="mb-3">
                    <Form.Label>* Password:</Form.Label>
                    <div className="d-flex">
                      <Form.Control
                        type={showPassword ? "text" : "password"}
                        className="w-50 inp-s"
                        required
                        onChange={handleChange}
                        name="password"
                      />
                      <Form.Check
                        type="checkbox"
                        label="Show password"
                        className="mt-2 mx-2"
                        id="showPassword"
                        onChange={() => setShowPassword((prev) => !prev)}
                      />
                    </div>
                  </Form.Group>
                  <Form.Group controlId="username" className="mb-3">
                    <Form.Label> Phone Number:</Form.Label>
                    <PhoneInput
                      className="phoneInp"
                      country="gb"
                      onChange={handlePhone} 
                      // onlyCountries={["sa"]}
                      countryCodeEditable={false}
                      inputProps={{
                        name: "phone",
                        required: true,
                      }}
                      style={{ width: "500px !important" }}
                    />
                    {/* <Form.Control
                      type="text"
                      name="phone"
                      required
                      className="w-50 inp-s"
                      onChange={handleChange}
                    /> */}
                  </Form.Group>
                  {/* <Form.Group controlId="username" className="mb-3">
                    <Form.Label> Address:</Form.Label>
                    <Form.Control
                      type="text"
                      name="address"
                      className="w-50 inp-s"
                      onChange={handleChange}
                    />
                  </Form.Group> */}

                  <Button type="submit" className="w-25 form-btn" disabled={isLoader}>
                    Sign Up  {isLoader &&  <div class="spinner-border spinner-border-sm mx-2" role="status">    </div> } 
                  </Button>
                </Form>
              </Card>
            </Col>

            <Col md={3} className="mt-4 mt-md-0">
              <Card className="p-4">
                <h5>Already have an Account?</h5>
                <Link to={"/Login"} className="w-50 create-acc">
                  Sign In
                </Link>
              </Card>
            </Col>
          </Row>

          <Footer />
        </Container>
      </div>
    </>
  );
};

export default Login;
